module.exports = __webpack_public_path__ + "img/crypto-ltc.feb21612.svg";